// extracted by mini-css-extract-plugin
export default {"spotifyImage":"Login_spotifyImage__+x7uW","headerBar":"Login_headerBar__njJ4E","spotifyButton":"Login_spotifyButton__9scxu","logIN":"Login_logIN__rc28S"};